import React from "react";
import DictionaryEntryForm from "../../components/dictionaries/DictionaryEntryForm";
import PremiumFormPanel from "../../components/PremiumFormPanel";
import useDictionaryFormData from "../../hooks/useDictionaryFormData";

/** Przygotowuje dodanie wpisu do słownika wybranego w konfiguracji firmy. */
export default function AddDictionaryEntryPage({
  organization,
  token,
  definition,
  listPath,
}) {
  const resource = useDictionaryFormData(organization, token, definition.kind);
  return (
    <PremiumFormPanel
      title={`Dodaj wpis — ${definition.label}`}
      description="Zmiana będzie dostępna w nowych zleceniach."
      resource={resource}
      error={resource.accessError}
      loadingLabel="Ładowanie wpisu…"
      backTo={listPath}
    >
      <DictionaryEntryForm
        token={token}
        url={resource.url}
        definition={definition}
        entries={resource.entries}
        listPath={listPath}
      />
    </PremiumFormPanel>
  );
}
